import { render } from "./CameraStatusBrief.vue?vue&type=template&id=2b660b2d&ts=true"
import script from "./CameraStatusBrief.vue?vue&type=script&lang=ts"
export * from "./CameraStatusBrief.vue?vue&type=script&lang=ts"

import "./CameraStatusBrief.vue?vue&type=style&index=0&id=2b660b2d&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__